export default __webpack_public_path__ + "static/media/bidenj.8156bbc2.png";